import { render, staticRenderFns } from "./VrstaSkupaBase.vue?vue&type=template&id=6bc4a5a7&scoped=true&"
import script from "./VrstaSkupaBase.vue?vue&type=script&lang=js&"
export * from "./VrstaSkupaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc4a5a7",
  null
  
)

export default component.exports